import { Dispatch } from "redux";
import { All, KeyValue } from "../interfaces";
import * as actions from "../common/actions";
import { connect } from "react-redux";
import BankFindDetails from "../components/BankFind/BankFindDetails";
import { updateFilter, updateSearch } from "../common/actions";

export function mapStateToProps({ appState }: All) {
  return {
    appState: (appState as KeyValue)[appState.app],
  };
}
export function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateLocations: (city: string, state: string, county: string) => {
      dispatch(updateFilter("stalp", state));
      dispatch(updateSearch("city", city));
      dispatch(updateFilter("county", county));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BankFindDetails);
